import { getUser, isWeaveUser } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { useScopedAppFlagStore } from '@frontend/scope';
import { WeaveRewindPrefixes } from '@frontend/tracking-prefixes';
import { WeaveRewindLogo } from '@frontend/weave-rewind-logo';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { CUSTOM_COLOR, fontFamily } from './styles';
import { useChatPopup } from './use-chat-popup';

const TeamChatButton = ({ onModalClose }: { onModalClose: () => void }) => {
  const { t } = useTranslation('dashboard');
  const { handleOpenMessage } = useChatPopup();

  const onTeamChatOpen = () => {
    handleOpenMessage();
    onModalClose();
  };

  return (
    <Button
      css={buttonTextStyles}
      iconName='chat'
      onClick={onTeamChatOpen}
      trackingId={WeaveRewindPrefixes.Modal + '-share-video-team-chat-button'}
    >
      {t('Chat with your team')}
    </Button>
  );
};

type Props = {
  onDownload: () => void;
  onModalClose: () => void;
  onWatchAgain: () => void;
};

export const ShareVideo = ({ onModalClose, onWatchAgain }: Props) => {
  const { t } = useTranslation('dashboard');
  const { getCustomizationFlagValue } = useScopedAppFlagStore();
  const hasChatCustomizationFlag = getCustomizationFlagValue('chat');
  const user = getUser();
  const weaveUser = isWeaveUser();
  const shouldHaveChat = hasChatCustomizationFlag && user && !weaveUser; // only show chat if user is not a weave user

  return (
    <div css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <WeaveRewindLogo width={323} height={242} />
      <div css={{ display: 'flex', columnGap: theme.spacing(0.5), marginTop: theme.spacing(4) }}>
        <Button
          css={buttonTextStyles}
          iconName='refresh'
          onClick={onWatchAgain}
          trackingId={WeaveRewindPrefixes.Modal + '-share-video-watch-again-button'}
        >
          {t('Watch Again')}
        </Button>
        {shouldHaveChat && <TeamChatButton onModalClose={onModalClose} />}
        {/* <Button css={buttonTextStyles} iconName='download-small' onClick={onDownload} trackingId={WeaveRewindPrefixes.Modal + '-share-video-download-button'}>
                    {t('Download')}
                </Button> */}
      </div>
      <Text color='white' textAlign='center' css={{ fontFamily, marginTop: theme.spacing(4) }}>
        {t(
          'Remind your coworkers to watch their Weave Rewinds. Cheers to another year of productivity, accomplishments, and working together. Happy New Year from your friends at Weave.'
        )}
      </Text>
      {/* <Text color='white' textAlign='center' css={{ fontFamily, marginTop: theme.spacing(4) }}>
                <Trans>
                Download and share your Weave Rewind on LinkedIn! Use <b>#2025weaverewind</b>
                </Trans>
            </Text> */}
    </div>
  );
};

const buttonTextStyles = {
  background: theme.colors.neutral30,
  border: `1px solid ${theme.colors.white}`,
  borderRadius: theme.borderRadius.full,
  color: CUSTOM_COLOR,
  '&:hover, &:focus': {
    background: theme.colors.neutral40,
  },
  svg: {
    color: CUSTOM_COLOR,
    transform: 'scale(-1, 1)',
  },
};
